import { api } from './client';

/** The signed-in user's invite link, issued on first request, and who joined through it. */
export function getMyReferrals() {
  return api.get('/referrals/me');
}
